import type { Pixel, Rectangle } from "@pdfking/renderer-api"

export type ImageArray = {
  readonly data: Uint8Array
} & Rectangle<Pixel>
